import { Box, Checkbox, TextField, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import {
  novaOcorrenciaSolicitacaoOrcamento,
  obterLoacaisAtendimentoAsync,
  obterParceirosOPMEPorSolicitacao
} from 'src/api/solicitacao-orcamento'
import { Autocomplete } from 'src/components/ui/Autocomplete'
import Button from 'src/components/ui/Button'
import UBox from 'src/components/ui/Ubox'
import { SynPerfis } from 'src/core/consts/synPerfis'
import { showNotificationErrorAPI } from 'src/core/helpers/notification'
import useAuth from 'src/hooks/useAuth'
import {
  NovaOcorrenciaSolicitacaoOcamentoCommand,
  ObjetoDescricaoGenerico
} from 'src/types'
import Swal from 'sweetalert2'

type Props = {
  solicitacaoId: string
  handleNovaOcorrencia: () => void
}

function NovaOcorrencia(props: Props) {
  const { perfilAtual } = useAuth()
  const perfisHospitalAdm =
    perfilAtual === SynPerfis.ADMIN_HOSPITAL ||
    perfilAtual === SynPerfis.OPERACIONAL_HOSPITAL

  const [loadingSalvar, setLoadingSalvar] = useState(false)
  const [observacao, setObservacao] = useState('')
  const [checkMedicoOcorrencia, setCheckMedicoOcorrencia] = useState(false)
  const [checkHospitalOcorrencia, setCheckHospitalOcorrencia] = useState(false)
  const [checkOpmeOcorrencia, setCheckOpmeOcorrencia] = useState(false)

  const [listaHospitaisSelecionado, setListaHospitaisSelecionado] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [listaHospitais, setListaHospitais] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [loadingHospitais, setLoadingHospitais] = useState<boolean>(true)

  const [listaOPMESelecionado, setListaOPMESelecionado] = useState<
    ObjetoDescricaoGenerico[]
  >([])
  const [listaOPME, setListaOPME] = useState<ObjetoDescricaoGenerico[]>([])
  const [loadingOPME, setLoadingOPME] = useState<boolean>(true)

  useEffect(() => {
    if (!props.solicitacaoId) {
      return
    }
    carregarHospitais()
    carregarOPME()
    limparTodosCampos()
  }, [props.solicitacaoId])

  function limparTodosCampos() {
    setObservacao('')
    setCheckMedicoOcorrencia(false)
    setCheckHospitalOcorrencia(false)
    setCheckOpmeOcorrencia(false)
    setListaHospitaisSelecionado([])
    setListaOPMESelecionado([])
  }

  const carregarHospitais = async () => {
    setLoadingHospitais(true)
    return obterLoacaisAtendimentoAsync(props.solicitacaoId)
      .then(response => {
        setListaHospitais(response.data || [])
      })
      .finally(() => {
        setLoadingHospitais(false)
      })
  }

  const carregarOPME = async () => {
    setLoadingOPME(true)
    return obterParceirosOPMEPorSolicitacao(props.solicitacaoId)
      .then(response => {
        setListaOPME(response.data || [])
      })
      .finally(() => {
        setLoadingOPME(false)
      })
  }

  async function handleSalvar() {
    try {
      var swalResult = {
        isConfirmed: false
      }

      if (checkHospitalOcorrencia && listaHospitaisSelecionado.length === 0) {
        Swal.fire(
          'Ops...',
          'Selecione o hospital para visualizar a ocorrência',
          'warning'
        )
        return
      }

      if (checkOpmeOcorrencia && listaOPMESelecionado.length === 0) {
        Swal.fire(
          'Ops...',
          'Selecione o OPME para visualizar a ocorrência',
          'warning'
        )
        return
      }

      setLoadingSalvar(true)
      var command: NovaOcorrenciaSolicitacaoOcamentoCommand = {
        id: props.solicitacaoId,
        observacao,
        medicoVisualizaOcorrencia: checkMedicoOcorrencia,
        parceiroHospitalVisualizaOcorrencia: checkHospitalOcorrencia,
        parceiroOpmeVisualizaOcorrencia: checkOpmeOcorrencia,
        hospitaisVisualizarOcorrencia: listaHospitaisSelecionado,
        opmeVisualizarOcorrencia: listaOPMESelecionado
      }

      await novaOcorrenciaSolicitacaoOrcamento(command)
      setLoadingSalvar(false)
      setObservacao('')
      props.handleNovaOcorrencia()
    } catch (e) {
      setLoadingSalvar(false)
      showNotificationErrorAPI(e)
    }
    setCheckMedicoOcorrencia(false)
    setCheckHospitalOcorrencia(false)
    setCheckOpmeOcorrencia(false)
  }

  const handleItemHospital = item => {
    setListaHospitaisSelecionado(item)
  }

  const handleItemOPME = item => {
    setListaOPMESelecionado(item)
  }

  function obterQuantidadeLinhasObservacao() {
    if (!observacao) return 1
    if (observacao.length > 40 && observacao.length <= 80) return 2
    if (observacao.length > 80) return 3
    return 1
  }

  return (
    <UBox loading={loadingOPME || loadingHospitais}>
      {/* command: {JSON.stringify(props)} */}

      <Box mt={2}>
        <TextField
          fullWidth
          label="Nova ocorrência"
          multiline
          rows={obterQuantidadeLinhasObservacao()}
          placeholder="Digite alguma ocorrência..."
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          value={observacao}
          onChange={e => setObservacao(e.target.value)}
        />
      </Box>

      {observacao && (
        <Box mt={2} style={{ display: 'flex', alignItems: 'center' }}>
          <Checkbox
            checked={checkMedicoOcorrencia}
            onChange={() => setCheckMedicoOcorrencia(!checkMedicoOcorrencia)}
            defaultChecked={false}
          />
          <Typography> Médico pode visualizar a ocorrência</Typography>
        </Box>
      )}
      {observacao && (
        <>
          <UBox
            render={!perfisHospitalAdm}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <Checkbox
              checked={checkHospitalOcorrencia}
              onChange={() =>
                setCheckHospitalOcorrencia(!checkHospitalOcorrencia)
              }
              defaultChecked={false}
            />
            <Typography>Hospital pode visualizar a ocorrência</Typography>
          </UBox>

          {checkHospitalOcorrencia && (
            <Autocomplete
              multiple
              erro={{}}
              name="hospitais"
              label="Selecione o Hospital"
              loading={loadingHospitais}
              value={listaHospitaisSelecionado}
              options={listaHospitais}
              getOptionSelected={option =>
                !!listaHospitaisSelecionado.find(l => l.id === option.id)
              }
              showCheck
              showAddButton
              getOptionLabel={option => `${option.descricao}`}
              onChange={(event, newValue: ObjetoDescricaoGenerico[]) => {
                handleItemHospital(newValue as ObjetoDescricaoGenerico[])
              }}
            />
          )}
        </>
      )}
      {observacao && (
        <>
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <Checkbox
              checked={checkOpmeOcorrencia}
              onChange={() => setCheckOpmeOcorrencia(!checkOpmeOcorrencia)}
              defaultChecked={false}
            />
            <Typography>
              {' '}
              Fornecedor OPME pode visualizar a ocorrência
            </Typography>
          </Box>

          {checkOpmeOcorrencia && (
            <Autocomplete
              multiple
              erro={{}}
              name="Fornecedores OPMEs"
              label="Selecione o Fornecedor OPME"
              loading={loadingOPME}
              value={listaOPMESelecionado}
              options={listaOPME}
              getOptionSelected={option =>
                !!listaOPMESelecionado.find(l => l.id === option.id)
              }
              showCheck
              showAddButton
              getOptionLabel={option => `${option.descricao}`}
              onChange={(event, newValue: ObjetoDescricaoGenerico[]) => {
                handleItemOPME(newValue as ObjetoDescricaoGenerico[])
              }}
            />
          )}
        </>
      )}

      <Box mt={1}>
        <Button
          disabled={!observacao || loadingSalvar}
          fullWidth
          onClick={handleSalvar}
          loading={loadingSalvar}
          secondaryLoading
        >
          Salvar
        </Button>
      </Box>
    </UBox>
  )
}

export default NovaOcorrencia
